import styled from 'styled-components';
import { screenXsMax, screenSmMin, spacer24, spacer32 } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-16ad49s-0"
})(["@media (max-width:", "){margin-left:-", ";margin-right:-", ";}@media (min-width:", "){margin-left:-", ";margin-right:-", ";}"], screenXsMax, spacer24, spacer24, screenSmMin, spacer32, spacer32);